import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_TO_SCHOOL_INFO_STATE } from "./consts";
import reducer from "./reducers";

// Use require to avoid circular dependency issue...
require("../analytics");

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TO_SCHOOL_INFO_STATE, builder => {
  builder.register(PATH_TO_SCHOOL_INFO_STATE, reducer);
});

export { reducer, PATH_TO_SCHOOL_INFO_STATE };

// actions
export { receiveSchoolInfo } from "./actions";
export {
  fetchSchoolInfoActionFactory,
  updateSchoolInfoActionFactory
} from "./actions/meta";

// selectors
export {
  userHasSchool,
  getUserSchoolId,
  getUserSchoolName,
  getUserSchoolLocalAuthority,
  getUserSchoolTown,
  isUserSchoolInternational,
  getUserSchoolMat,
  isSchoolPrivate
} from "./selectors";

export type {
  SchoolInfoType,
  PartialSchoolInfoType
} from "./models/SchoolInfo";
